import ChangePasswordPanel from './ChangePasswordPanel';

export default ChangePasswordPanel;
